import React from 'react';

import {useGate, useUnit} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {MetricCard, MetricCardGrid} from '@/widgets/MetricCard';
import {SummaryGate, summaryModel} from '@entities/summary/model';
import {formatNumberWithFraction} from '@utils/number';

export const CounterpartiesSummary = () => {
    const {t} = useTranslation();
    const {state} = useUnit(summaryModel);
    useGate(SummaryGate);

    return (
        <MetricCardGrid>
            <MetricCard
                iconName="mail"
                label={t('page_invoices.nds_in')}
                value={formatNumberWithFraction(state.data?.incomingTotalVat)}
            />
            <MetricCard
                iconName="output"
                label={t('page_invoices.nds_out')}
                value={formatNumberWithFraction(state.data?.outgoingTotalVat)}
            />
            <MetricCard
                iconName="balance"
                label={t('page_invoices.balance')}
                value={formatNumberWithFraction(state.data?.vatBalance)}
            />
        </MetricCardGrid>
    );
};
